import React from 'react'

export default function ContactSection() {
  return (
    <section
              id="contact"
              class="flex  items-between py-16 w-full sm:py-20 bg-gray-100"
            >
              <div class="container mx-auto px-4">
                <h3 class="text-3xl font-semibold text-center sm:mb-16 text-brand">
                  Contact Us
                </h3>
                <div class="flex  flex-col sm:flex-row  items-center ">
                  <div class="sm:w-1/2 w-full sm:mr-8">
                    <form action="#" method="POST">
                      <div class="w-full flex flex-col sm:flex-row justify-center items-center space-x-3">
                        <div class="mb-4 w-full">
                          <label
                            for="name"
                            class="block text-sm font-medium text-gray-700"
                          >
                            Name
                          </label>
                          <input
                            type="name"
                            id="name"
                            name="name"
                            class="mt-1 block w-full h-12 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-brand focus:border-brand sm:text-sm"
                            required
                          />
                        </div>

                        <div class="mb-4 w-full">
                          <label
                            for="email"
                            class="block text-sm font-medium text-gray-700"
                          >
                            Email
                          </label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            class="mt-1 block w-full h-12 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-brand focus:border-brand sm:text-sm"
                            required
                          />
                        </div>
                      </div>

                      <div class="mb-4">
                        <label
                          for="message"
                          class="block text-sm font-medium text-gray-700"
                        >
                          Message
                        </label>
                        <textarea
                          id="message"
                          name="message"
                          rows="10"
                          class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-brand focus:border-brand sm:text-sm"
                          required
                        ></textarea>
                      </div>
                      <button
                        type="submit"
                        class="w-full bg-brand h-12 hover:bg-brand-dark text-white font-semibold py-2 px-4 rounded-md shadow-md transition duration-300"
                      >
                        Send
                      </button>
                    </form>
                  </div>

                  <div class="sm:w-1/2 h-full flex flex-col justify-between items-between w-full space-y-6 sm:space-y-10 sm:ml-8 mt-8 sm:mt-0 ">
                    
                    <div class="flex flex-col space-y-2 sm:space-y-3 ">
                    <h4 class="text-xl font-semibold mb-4">Contact Information</h4>

                      <div class="flex items-center mb-2 space-x-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M12 14c2.206 0 4-1.794 4-4s-1.794-4-4-4s-4 1.794-4 4s1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2s-2-.897-2-2s.897-2 2-2z"
                          />
                          <path
                            fill="currentColor"
                            d="M11.42 21.814a.998.998 0 0 0 1.16 0C12.884 21.599 20.029 16.44 20 10c0-4.411-3.589-8-8-8S4 5.589 4 9.995c-.029 6.445 7.116 11.604 7.42 11.819zM12 4c3.309 0 6 2.691 6 6.005c.021 4.438-4.388 8.423-6 9.73c-1.611-1.308-6.021-5.294-6-9.735c0-3.309 2.691-6 6-6z"
                          />
                        </svg>
                        <p class="font-medium text-md text-gray-600 ">
                          <strong>Address:</strong> Edna Mall , Addis ababa,
                          Ethiopia,
                        </p>
                      </div>
                      <div class="flex items-center mb-2 space-x-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="currentColor"
                            d="M18.4 20.75h-.23a16.73 16.73 0 0 1-7.27-2.58a16.58 16.58 0 0 1-5.06-5.05a16.72 16.72 0 0 1-2.58-7.29A2.3 2.3 0 0 1 3.8 4.1a2.32 2.32 0 0 1 1.6-.84H8a2.36 2.36 0 0 1 2.33 2a9.29 9.29 0 0 0 .53 2.09a2.37 2.37 0 0 1-.54 2.49l-.61.61a12 12 0 0 0 3.77 3.75l.61-.6a2.37 2.37 0 0 1 2.49-.54a9.57 9.57 0 0 0 2.09.53a2.35 2.35 0 0 1 2 2.38v2.4a2.36 2.36 0 0 1-2.35 2.36ZM8 4.75H5.61a.87.87 0 0 0-.61.31a.83.83 0 0 0-.2.62a15.17 15.17 0 0 0 2.31 6.62a15 15 0 0 0 4.59 4.59a15.34 15.34 0 0 0 6.63 2.36A.89.89 0 0 0 19 19a.88.88 0 0 0 .25-.61V16a.86.86 0 0 0-.74-.87a11.42 11.42 0 0 1-2.42-.6a.87.87 0 0 0-.91.19l-1 1a.76.76 0 0 1-.9.12a13.53 13.53 0 0 1-5.11-5.1a.74.74 0 0 1 .12-.9l1-1a.85.85 0 0 0 .19-.9a11.28 11.28 0 0 1-.6-2.42a.87.87 0 0 0-.88-.77Z"
                          />
                        </svg>
                        <p class="font-medium text-md text-gray-600 ">
                          <strong>Phone:</strong> (+251) 900000000
                        </p>
                      </div>
                      <div class="flex items-center mb-2 space-x-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6"
                          viewBox="0 0 32 32"
                        >
                          <path
                            fill="none"
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M29 9v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9m26 0a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2m26 0l-11.862 8.212a2 2 0 0 1-2.276 0L3 9"
                          />
                        </svg>
                        <p class="font-medium text-md text-gray-600 space-x-2 ">
                          <strong>Email:</strong> contact@example.com
                        </p>
                      </div>
                    </div>

                    <div class="flex flex-col space-y-2 sm:space-y-3 ">
                      <h4 class="text-xl font-semibold mb-4">Follow Us</h4>
                      <div class="flex space-x-4">
                        <a
                          href="https://facebook.com/yourpage"
                          target="_blank"
                          rel="noreferrer"
                          class="text-gray-600 hover:text-gray-900"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            viewBox="0 0 256 256"
                          >
                            <path
                              fill="#1877F2"
                              d="M256 128C256 57.308 198.692 0 128 0C57.308 0 0 57.307 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.347-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.958 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445"
                            />
                            <path
                              fill="#FFF"
                              d="m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A128.959 128.959 0 0 0 128 256a128.9 128.9 0 0 0 20-1.555V165h29.825"
                            />
                          </svg>
                        </a>
                        <a
                          href="https://twitter.com/yourprofile"
                          target="_blank"
                          rel="noreferrer" 
                          class="text-gray-600 hover:text-gray-900"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            viewBox="0 0 24 24"
                          >
                            <path
                              fill="currentColor"
                              d="M17.751 3h3.067l-6.7 7.625L22 21h-6.172l-4.833-6.293L5.464 21h-3.07l7.167-8.155L2 3h6.328l4.37 5.752zm-1.076 16.172h1.7L7.404 4.732H5.58z"
                            />
                          </svg>
                        </a>
                        <a
                          href="https://instagram.com/yourprofile"
                          target="_blank"
                          rel="noreferrer" 
                          class="text-gray-600 hover:text-gray-900"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            viewBox="0 0 256 256"
                          >
                            <g fill="none">
                              <rect
                                width="256"
                                height="256"
                                fill="url(#skillIconsInstagram0)"
                                rx="60"
                              />
                              <rect
                                width="256"
                                height="256"
                                fill="url(#skillIconsInstagram1)"
                                rx="60"
                              />
                              <path
                                fill="#fff"
                                d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604h.031Zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396c0 26.688-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413c0-26.704.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5c3.5-3.5 6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563v.025Zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12v.004Zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355c0 28.361 22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355h.002Zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334c-18.41 0-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334Z"
                              />
                              <defs>
                                <radialGradient
                                  id="skillIconsInstagram0"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#FD5" />
                                  <stop offset=".1" stop-color="#FD5" />
                                  <stop offset=".5" stop-color="#FF543E" />
                                  <stop offset="1" stop-color="#C837AB" />
                                </radialGradient>
                                <radialGradient
                                  id="skillIconsInstagram1"
                                  cx="0"
                                  cy="0"
                                  r="1"
                                  gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stop-color="#3771C8" />
                                  <stop offset=".128" stop-color="#3771C8" />
                                  <stop
                                    offset="1"
                                    stop-color="#60F"
                                    stop-opacity="0"
                                  />
                                </radialGradient>
                              </defs>
                            </g>
                          </svg>
                        </a>
                        <a
                          href="https://linkedin.com/in/yourprofile"
                          target="_blank"
                          rel="noreferrer" 
                          class="text-gray-600 hover:text-gray-900"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            viewBox="0 0 256 256"
                          >
                            <g fill="none">
                              <rect
                                width="256"
                                height="256"
                                fill="#fff"
                                rx="60"
                              />
                              <rect
                                width="256"
                                height="256"
                                fill="#0A66C2"
                                rx="60"
                              />
                              <path
                                fill="#fff"
                                d="M184.715 217.685h29.27a4 4 0 0 0 4-3.999l.015-61.842c0-32.323-6.965-57.168-44.738-57.168c-14.359-.534-27.9 6.868-35.207 19.228a.32.32 0 0 1-.595-.161V101.66a4 4 0 0 0-4-4h-27.777a4 4 0 0 0-4 4v112.02a4 4 0 0 0 4 4h29.268a4 4 0 0 0 4-4v-55.373c0-15.657 2.97-30.82 22.381-30.82c19.135 0 19.383 17.916 19.383 31.834v54.364a4 4 0 0 0 4 4ZM38 59.627c0 11.865 9.767 21.627 21.632 21.627c11.862-.001 21.623-9.769 21.623-21.631C81.253 47.761 71.491 38 59.628 38C47.762 38 38 47.763 38 59.627Zm6.959 158.058h29.307a4 4 0 0 0 4-4V101.66a4 4 0 0 0-4-4H44.959a4 4 0 0 0-4 4v112.025a4 4 0 0 0 4 4Z"
                              />
                            </g>
                          </svg>
                        </a>
                        <a
                          href="https://t.me/yourprofile"
                          target="_blank"
                          rel="noreferrer" 
                          class="text-gray-60
                          0 hover:text-gray-900"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-6 w-6"
                            viewBox="0 0 256 256"
                          >
                            <defs>
                              <linearGradient
                                id="logosTelegram0"
                                x1="50%"
                                x2="50%"
                                y1="0%"
                                y2="100%"
                              >
                                <stop offset="0%" stop-color="#2AABEE" />
                                <stop offset="100%" stop-color="#229ED9" />
                              </linearGradient>
                            </defs>
                            <path
                              fill="url(#logosTelegram0)"
                              d="M128 0C94.06 0 61.48 13.494 37.5 37.49A128.038 128.038 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51c0-33.934-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0Z"
                            />
                            <path
                              fill="#FFF"
                              d="M57.94 126.648c37.32-16.256 62.2-26.974 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441c1.06-.017 3.42.245 4.96 1.49c1.28 1.05 1.64 2.47 1.82 3.467c.16.996.38 3.266.2 5.038c-1.92 20.24-10.26 69.356-14.5 92.026c-1.78 9.592-5.32 12.808-8.74 13.122c-7.44.684-13.08-4.912-20.28-9.63c-11.26-7.386-17.62-11.982-28.56-19.188c-12.64-8.328-4.44-12.906 2.76-20.386c1.88-1.958 34.64-31.748 35.26-34.45c.08-.338.16-1.598-.6-2.262c-.74-.666-1.84-.438-2.64-.258c-1.14.256-19.12 12.152-54 35.686c-5.1 3.508-9.72 5.218-13.88 5.128c-4.56-.098-13.36-2.584-19.9-4.708c-8-2.606-14.38-3.984-13.82-8.41c.28-2.304 3.46-4.662 9.52-7.072Z"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
  )
}
